import PropTypes from 'prop-types';

const propType = {
  info: PropTypes.arrayOf(PropTypes.string),
  company: PropTypes.arrayOf(PropTypes.string),
  career: PropTypes.arrayOf(PropTypes.string),
  experience: PropTypes.arrayOf(PropTypes.string),
  hobbies: PropTypes.arrayOf(PropTypes.string),
  softSkills: PropTypes.arrayOf(PropTypes.string),
  hardSkills: PropTypes.arrayOf(PropTypes.string),
  languages: PropTypes.arrayOf(PropTypes.string),
  contacts: PropTypes.arrayOf(PropTypes.string),
  moods: PropTypes.arrayOf(PropTypes.string),
  media: PropTypes.arrayOf(PropTypes.string),
  socialMedia: PropTypes.arrayOf(PropTypes.string),
  legalFinances: PropTypes.arrayOf(PropTypes.string),
};

const defaultProp = {
  info: [],
  company: [],
  career: [],
  experience: [],
  hobbies: [],
  softSkills: [],
  hardSkills: [],
  languages: [],
  contacts: [],
  moods: [],
  media: [],
  socialMedia: [],
  legalFinances: [],
};

export default { propType, defaultProp };
